import { Box } from "@mui/material";
import React, { useMemo } from "react";

import { EnergyBalanceForPlayerChart } from "@/modules/charts/EnergyBalanceCharts/EnergyBalanceForPlayerChart";
import { ResourcesPerProductionTypeChart } from "@/modules/charts/ResourcesPerProductionTypeChart";
import { ResourcesPerStepChart } from "@/modules/charts/ResourcesPerStepChart";
import { Tabs } from "@/modules/common/components/Tabs";
import { Typography } from "@/modules/common/components/Typography";
import { PlayBox } from "@/modules/play/Components";
import { usePersona } from "@/modules/play/context/hooks/player";
import { useTranslation } from "@/modules/translations";

export { StatsGraphs };

function StatsGraphs() {
  const { t } = useTranslation();
  const { getPersonaAtStep } = usePersona();

  const tabs = useMemo(() => {
    return [
      {
        label: t("page.player.statistics.tabs.energy-balance.label"),
        component: (
          <EnergyBalanceForPlayerChart getPersonaAtStep={getPersonaAtStep} />
        ),
      },
      {
        label: t("page.player.statistics.tabs.materials.label"),
        component: <MaterialsGraphTab />,
      },
      {
        label: t("page.player.statistics.tabs.metals.label"),
        component: <MetalsGraphTab />,
      },
    ];
  }, [getPersonaAtStep, t]);

  return (
    <PlayBox>
      <Box display="flex" flexDirection="column" gap={3} paddingTop={2}>
        <Typography sx={{ textAlign: "center", mb: 2 }} variant="h3">
          {t("page.player.statistics.title")}
        </Typography>
        <Box>
          <Tabs tabs={tabs} />
        </Box>
      </Box>
    </PlayBox>
  );
}

function MaterialsGraphTab() {
  const { currentPersona, getPersonaAtStep } = usePersona();

  return (
    <>
      <ResourcesPerStepChart
        getPersonaAtStep={getPersonaAtStep}
        resourceType="materials"
      />
      <ResourcesPerProductionTypeChart
        persona={currentPersona}
        resourceType="materials"
      />
    </>
  );
}

function MetalsGraphTab() {
  const { currentPersona, getPersonaAtStep } = usePersona();

  return (
    <>
      <ResourcesPerStepChart
        getPersonaAtStep={getPersonaAtStep}
        resourceType="metals"
      />
      <ResourcesPerProductionTypeChart
        persona={currentPersona}
        resourceType="metals"
      />
    </>
  );
}
